import React from 'react';

// Import your local images
import leftImage from '../assets/logo png/birds.png';
import centerImage from '../assets/Media (2).png';
import rightImage from '../assets/logo png/birds2.png';

const UBLanding = () => {
  return (
    <div className="w-full bg-gradient-to-br from-white via-gray-50 to-white text-gray-900 font-sans overflow-hidden relative">
      {/* Animated background orbs */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-orange-200/40 rounded-full blur-3xl animate-pulse" />
        <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-yellow-200/40 rounded-full blur-3xl animate-pulse delay-1000" />
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-orange-100/30 rounded-full blur-3xl" />
      </div>

      <div className="relative z-10 container mx-auto px-4 py-8 md:py-12">
        {/* Heading */}
        <div className="text-center mb-8 mt-8 md:mt-12 animate-fade-in-up">
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold leading-tight">
            <span className="block bg-gradient-to-r from-red-500 via-yellow-500 to-red-500 bg-clip-text text-transparent animate-gradient-x">
              Leading Innovation <br />in Games Across the World
            </span>
          </h1>
        </div>

        {/* Three images row – responsive grid */}
        <div className="flex flex-col md:grid md:grid-cols-[1fr_auto_1fr] md:items-center gap-6 md:gap-0 mb-12">
          {/* Left decorative image */}
          <div className="flex justify-start md:justify-start">
            <div className="group relative w-28 md:w-56 transition-all duration-500 hover:scale-110">
              <div className="absolute inset-0 bg-orange-200/40 blur-2xl rounded-full group-hover:bg-orange-300/60 transition" />
              <div className="relative">
                <img
                  src={leftImage}
                  alt=""
                  className="w-full h-auto object-contain rounded-full"
                />
              </div>
            </div>
          </div>

          {/* Central circle – larger size, badge moved down */}
          <div className="relative w-64 md:w-96 mx-auto group">
            <div className="absolute inset-0 bg-gradient-to-r from-orange-300 to-yellow-300 rounded-full blur-2xl opacity-50 group-hover:opacity-80 transition duration-500" />
            <div className="relative bg-white/40 backdrop-blur-md rounded-full p-2 shadow-xl">
              <div className="rounded-full overflow-hidden bg-white/20">
                <img
                  src={centerImage}
                  alt=""
                  className="w-full h-auto object-contain"
                />
              </div>
              {/* Badge – moved down with negative bottom */}
              <div className="absolute -bottom-4 left-1/2 -translate-x-1/2 bg-white/40 backdrop-blur-md rounded-2xl px-4 py-2 text-center border border-white/40 shadow-xl whitespace-nowrap">
                <div className="text-xl md:text-4xl font-bold bg-gradient-to-r from-orange-500 to-yellow-500 bg-clip-text text-transparent">
                  100  Millions +
                </div>
                <div className="text-xs md:text-base font-bold bg-gradient-to-r from-orange-500 to-yellow-500 bg-clip-text text-transparent uppercase">
                  Downloads
                </div>
              </div>
            </div>
          </div>

          {/* Right decorative image */}
          <div className="flex justify-end md:justify-end">
            <div className="group relative w-28 md:w-48 transition-all duration-500 hover:scale-110">
              <div className="absolute inset-0 bg-orange-200/10 blur-2xl rounded-full group-hover:bg-orange-100/10 transition" />
              <div className="relative z-10 rounded-full overflow-hidden bg-white/10 backdrop-blur-sm p-2 shadow-lg">
                <img
                  src={rightImage}
                  alt=""
                  className="w-full h-auto object-contain rounded-full"
                />
              </div>
            </div>
          </div>
        </div>

        {/* Stats cards (unchanged) */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {[
            { number: "60+", label: "Employees" },
            { number: "10+", label: "Advertising Partners" },
            { number: "600+", label: "Games Published" },
            { number: "20M+", label: "DAU" }
          ].map((stat, idx) => (
            <div
              key={idx}
              className="group relative bg-white/60 backdrop-blur-md rounded-2xl p-6 text-center transition-all duration-500 hover:bg-white/80 hover:scale-105 hover:shadow-2xl hover:shadow-orange-200/40 border border-white/40 hover:border-orange-300/60"
            >
              <div className="absolute inset-0 rounded-2xl bg-gradient-to-br from-orange-100/0 via-yellow-100/0 to-orange-100/0 group-hover:from-orange-100/30 group-hover:via-yellow-100/30 group-hover:to-orange-100/30 transition-all duration-500" />
              <div className="relative z-10">
                <div className="text-4xl md:text-5xl font-bold bg-gradient-to-r from-orange-500 to-yellow-500 bg-clip-text text-transparent group-hover:from-orange-600 group-hover:to-yellow-600 transition">
                  {stat.number}
                </div>
                <div className="text-gray-700 mt-2 group-hover:text-gray-900 transition">
                  {stat.label}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <style jsx>{`
        @keyframes fade-in-up {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        @keyframes gradient-x {
          0%, 100% { background-position: 0% 50%; }
          50% { background-position: 100% 50%; }
        }
        .animate-fade-in-up {
          animation: fade-in-up 0.8s ease-out;
        }
        .animate-gradient-x {
          background-size: 200% auto;
          animation: gradient-x 3s ease infinite;
        }
      `}</style>
    </div>
  );
};

export default UBLanding;